import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2, Shield } from "lucide-react";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import AppShell from "./pages/AppShell";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import Weapons from "./pages/Weapons";
import Processes from "./pages/Processes";
import Agenda from "./pages/Agenda";
import Documents from "./pages/Documents";
import ClientPortal from "./pages/ClientPortal";
import "@/App.css";
import "@/mobile-fixes.css";

function LoadingScreen() {
  return (
    <div className="auth-loading">
      <div className="brand-mark"><Shield size={22}/></div>
      <Loader2 className="spin" size={22}/>
      <p>Carregando painel…</p>
    </div>
  );
}

function Protected({ children, allow }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }}/>;
  if (allow && !allow.includes(user.role)) {
    return <Navigate to={user.role === "client" ? "/portal" : "/dashboard"} replace/>;
  }
  return children;
}

function Router() {
  return (
    <Routes>
      <Route path="/login" element={<Login/>}/>
      <Route element={<Protected><AppShell/></Protected>}>
        <Route path="/dashboard" element={<Protected allow={["professional","admin"]}><Dashboard/></Protected>}/>
        <Route path="/clients" element={<Protected allow={["professional","admin"]}><Clients/></Protected>}/>
        <Route path="/weapons" element={<Protected allow={["professional","admin"]}><Weapons/></Protected>}/>
        <Route path="/processes" element={<Protected allow={["professional","admin"]}><Processes/></Protected>}/>
        <Route path="/agenda" element={<Protected allow={["professional","admin"]}><Agenda/></Protected>}/>
        <Route path="/documents" element={<Protected allow={["professional","admin"]}><Documents/></Protected>}/>
        <Route path="/portal" element={<Protected allow={["client"]}><ClientPortal/></Protected>}/>
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace/>}/>
      <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Router />
        <Toaster position="bottom-right" theme="dark" richColors closeButton/>
      </BrowserRouter>
    </AuthProvider>
  );
}
